(function () {
  if (window.__rfCouponOverrideBound) return;
  window.__rfCouponOverrideBound = true;

  function sanitizeRedirectPath(rawPath) {
    var fallbackPath = '/cart';
    var rawValue = String(rawPath || '').trim() || fallbackPath;

    try {
      var parsedUrl = new URL(rawValue, window.location.origin);
      parsedUrl.searchParams.delete('preview_theme_id');
      parsedUrl.searchParams.delete('_fd');
      parsedUrl.searchParams.delete('pb');
      return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
    } catch (error) {
      return fallbackPath;
    }
  }

  function stripPreviewParamsFromCurrentUrl() {
    try {
      var currentUrl = new URL(window.location.href);
      if (currentUrl.pathname.indexOf('/cart') !== 0) return;

      var hadPreviewParams = false;
      ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
        if (currentUrl.searchParams.has(key)) {
          currentUrl.searchParams.delete(key);
          hadPreviewParams = true;
        }
      });

      if (!hadPreviewParams) return;

      var cleanUrl = currentUrl.pathname + currentUrl.search + currentUrl.hash;
      window.location.replace(cleanUrl || '/cart');
    } catch (error) {
      // Ignore malformed URLs and allow normal cart flow.
    }
  }

  function applyCoupon(rawCode, redirectPath) {
    var code = String(rawCode || '').trim();
    if (!code) return;

    var redirect = sanitizeRedirectPath(redirectPath);
    var discountUrl = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);

    window.location.assign(discountUrl);
  }

  function removeCoupon(redirectPath) {
    var redirect = sanitizeRedirectPath(redirectPath);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        discount: ''
      })
    })
      .then(function () {
        window.location.assign(redirect);
      })
      .catch(function () {
        window.location.assign(redirect);
      });
  }

  stripPreviewParamsFromCurrentUrl();

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('[data-rf-apply-coupon]');
      if (!button) return;
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      applyCoupon(button.getAttribute('data-rf-apply-coupon'), button.getAttribute('data-rf-coupon-redirect'));
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var removeButton = event.target.closest('[data-rf-remove-coupon]');
      if (!removeButton) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      removeCoupon(removeButton.getAttribute('data-rf-coupon-redirect'));
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('[data-rf-coupon-form]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var input = form.querySelector('input[name="coupon_code"]');
      if (!input) return;

      applyCoupon(input.value, form.getAttribute('data-rf-coupon-redirect'));
    },
    true
  );
})();
